module.exports = __webpack_public_path__ + "media/images/front/sp/features/search/doctors/icon_japanese-map-217bafe9902c464fba669c264f605766.svg";